/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Backup_Llm_NoneInputs */

const en_ad_backup_llm_none = /** @type {(inputs: Ad_Backup_Llm_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const fr_ad_backup_llm_none = /** @type {(inputs: Ad_Backup_Llm_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun`)
};

const de_ad_backup_llm_none = /** @type {(inputs: Ad_Backup_Llm_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keiner`)
};

const it_ad_backup_llm_none = /** @type {(inputs: Ad_Backup_Llm_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno`)
};

const ru_ad_backup_llm_none = /** @type {(inputs: Ad_Backup_Llm_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Никто`)
};

const es_ad_backup_llm_none = /** @type {(inputs: Ad_Backup_Llm_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguno`)
};

const zh_cn2_ad_backup_llm_none = /** @type {(inputs: Ad_Backup_Llm_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有任何`)
};

const ja_ad_backup_llm_none = /** @type {(inputs: Ad_Backup_Llm_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なし`)
};

const hi_ad_backup_llm_none = /** @type {(inputs: Ad_Backup_Llm_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई नहीं`)
};

const pt_pt2_ad_backup_llm_none = /** @type {(inputs: Ad_Backup_Llm_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Ad_Backup_Llm_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_backup_llm_none = /** @type {((inputs?: Ad_Backup_Llm_NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Backup_Llm_NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_backup_llm_none(inputs)
	if (locale === "de") return de_ad_backup_llm_none(inputs)
	if (locale === "it") return it_ad_backup_llm_none(inputs)
	if (locale === "ru") return ru_ad_backup_llm_none(inputs)
	if (locale === "es") return es_ad_backup_llm_none(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_backup_llm_none(inputs)
	if (locale === "ja") return ja_ad_backup_llm_none(inputs)
	if (locale === "hi") return hi_ad_backup_llm_none(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_backup_llm_none(inputs)
	return en_ad_backup_llm_none(inputs)
});